import React from 'react';
import WorkplaceWorkersList from './WorkplaceWorkersList';
import Loading from '../../../../../Components/Loading';
import useRootWorkplaceInfo from '../../../Hooks/useRootWorkplaceInfo';

interface Props {
	showAllWorkplaces: boolean;
}

const WorkplaceWorkersListWrapper: React.FC<Props> = ({
	showAllWorkplaces,
}) => {
	const { isLoading, rootWorkplace } = useRootWorkplaceInfo();

	if (isLoading) {
		return <Loading />;
	}

	return (
		<WorkplaceWorkersList
			showAllWorkplaces={showAllWorkplaces}
			rootWorkplace={rootWorkplace}
		/>
	);
};

export default WorkplaceWorkersListWrapper;
